import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import AuthLayout from '@/components/Auth/AuthLayout.vue';
import AuthCardHeader from '@/components/Auth/AuthCardHeader.vue';
import CButton from '@/components/shared/CButton/CButton.vue';
import CError from '@/components/shared/CError.vue';
import CInput from '@/components/shared/CInput/CInput.vue';
import { sendPasswordResetEmail } from '@/api/auth';
import { externalAuthErrorMessage } from '@/utils/authUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  setup(__props) {

const email = ref('');
const sending = ref(false);
const sent = ref(false);
const errorMessage = ref('');

const submit = async () => {
    errorMessage.value = '';

    sending.value = true;
    try {
        await sendPasswordResetEmail(email.value.trim());
        sent.value = true;
    } catch (error) {
        errorMessage.value = externalAuthErrorMessage(error, 'We could not send the email. Please try again.');
    } finally {
        sending.value = false;
    }
};

return { __sfc: true,email, sending, sent, errorMessage, submit, ValidationObserver, ValidationProvider, AuthLayout, AuthCardHeader, CButton, CError, CInput }
}

})